// @ts-nocheck
/* Store Custom File */
import { NavigationDrawerAccordionPresentationProps } from "@store/Library/Components/NavigationDrawerAccordion";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import setFlyoutDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetFlyoutDrawerIsOpen";
import setInitialValues from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetInitialValues";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import translate from "@insite/client-framework/Translate";
import { IconPresentationProps, IconWrapper } from "@insite/mobius/Icon";
import { MappedLink } from "@insite/mobius/Menu";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React, { FC, useEffect } from "react";
import AccountMessagesCount, {
    AccountMessagesCountPresentationProps,
} from "@store/Library/Components/Toolkit/AccountMessagesCount";
import Menu from "@store/Library/Components/Toolkit/Icons/Menu";
import Drawer, { DrawerPresentationProps } from "@store/MobiusOverrides/Drawer/Drawer";
import useIsDuplicate from "@toolkit/Framework/Common/Hooks/useIsDuplicate";
import { NavigationLinkModel } from "@store/Overrides/Widgets/Header/MainNavigation";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import NavigationDrawerAccordion from "@store/Library/Components/NavigationDrawerAccordion";
import NavigationDrawerLink, {
    NavigationDrawerLinkPresentationProps,
} from "@store/Library/Components/NavigationDrawerLink";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import getColor from "@insite/mobius/utilities/getColor";
import Button, { ButtonIcon, ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import PersonLine from "@store/Library/Components/Toolkit/Icons/Person/PersonLine";
import HomePin from "@store/Library/Components/Icons/HomePin";
import PowerBolt from "@store/Library/Components/Icons/PowerBolt";
import Upload from "@store/Library/Components/Toolkit/Icons/Upload";
import { headerIconButtonProps } from "@store/Themes/common/props/header";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import CollapsableSideMenu, {
    CollapsableSideMenuPresentationProps,
    smallCollapsableSideMenuProps,
} from "@store/Library/Components/CollapsableSideMenu";
import constants from "@store/constants";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InlineAddress, { InlineAddressPresentationProps } from "@store/Library/Components/InlineAddress";
import loadBillTos from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTos";
import loadCurrentBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadCurrentBillTo";
import loadCurrentShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTo";
import loadCurrentShipTos from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTos";
import {
    getBillTosDataView,
    getCurrentBillToState,
} from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import {
    getCurrentShipTosDataView,
    getCurrentShipToState,
} from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import setChangeCustomerModalIsOpen from "@store/Framework/Store/Greif/Components/ChangeCustomerModal/Handlers/ChangeCustomerIsOpen";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { iconScalableStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import { useSession, useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import { LinkModelWithIcon } from "@toolkit/Framework/Store/Links/LinksSelectors";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import { useHeaderPage, useLocation } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { headerLinkListIcons } from "@store/Overrides/Widgets/Header/HeaderLinkList";
import { getLanguages } from "@insite/client-framework/Store/Context/ContextSelectors";
import setLanguage from "@insite/client-framework/Store/Context/Handlers/SetLanguage";
import LanguageLine from "@store/Library/Components/Icons/Language/LanguageLine";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import { shallowEqual } from "react-redux";

const secondaryNavigationZones = ["Left", "Right"];

export interface NavigationDrawerPresentationProps {}

export interface NavigationDrawerProps extends NavigationDrawerPresentationProps {
    isCompactHeaderFlyout?: boolean;
    rootElementSelector?: string;
    showQuickOrder?: boolean;
    showOrderUpload?: boolean;
    uniqueId?: string;
    // Unused properties kept for backwards compatibility
    links: MappedLink[];
    quickOrderLink: PageLinkModel | undefined;
    displayVmiNavigation?: boolean;
    vmiPageLinks?: (PageLinkModel | undefined)[];
    displayModeSwitch?: boolean;
    currentMode?: string;
    showFlyoutPricingToggle?: boolean;
    showFlyoutInventoryToggle?: boolean;
    allowOpenParentLinks?: boolean;
    showAllProducts?: boolean;
    showMyProducts?: boolean;
    allProductsLink: NavigationLinkModel;
    myProductsLink: NavigationLinkModel;
    orderUploadLink?: PageLinkModel;
}

export interface NavigationDrawerStyles {
    accountCollapsableSideMenu?: CollapsableSideMenuPresentationProps;
    accountNavigationDrawerAccordion?: NavigationDrawerAccordionPresentationProps;
    changeAccountLink?: LinkPresentationProps;
    customerAddress?: InlineAddressPresentationProps;
    customerAddressLabel?: TypographyPresentationProps;
    customerNavigationDrawerAccordion?: NavigationDrawerAccordionPresentationProps;
    drawer?: DrawerPresentationProps;
    drawerTrigger?: ButtonPresentationProps;
    drawerTriggerAccountMessagesCountStyles?: AccountMessagesCountPresentationProps;
    drawerTriggerIcon?: IconPresentationProps;
    languageMenuNavigationDrawerAccordion?: NavigationDrawerAccordionPresentationProps;
    languageMenuNavigationDrawerLink?: NavigationDrawerLinkPresentationProps;
    myProductsButton?: ButtonPresentationProps;
    primaryNavigationWrapper?: InjectableCss;
    secondaryNavigationDrawerLink?: NavigationDrawerLinkPresentationProps;
    secondaryNavigationWrapper?: InjectableCss;
    sectionWrapper?: InjectableCss;
    tertiaryNavigationDrawerLink?: NavigationDrawerLinkPresentationProps;
}

export const navigationDrawerStyles: NavigationDrawerStyles = {
    drawerTrigger: mergeProps<NavigationDrawerStyles["drawerTrigger"]>(headerIconButtonProps, {
        css: css`
            position: relative;

            /* Needs to be here to properly override "headerIconButtonProps" */
            > ${IconWrapper} {
                ${iconScalableStyles(pxToRem(30))}
            }
        `,
    }),
    drawerTriggerIcon: { src: Menu },
    drawerTriggerAccountMessagesCountStyles: {
        position: pxToRemArray([2, 0, 0, 24]),
        extendedStyles: {
            messagesCountText: {
                css: css`
                    &&& {
                        font-size: ${pxToRem(10)};
                        font-weight: ${x => x.theme.design.typography.weight.bold};
                        line-height: ${x => x.theme.design.typography.lineHeight.small};
                    }
                `,
            },
        },
    },
    drawer: {
        position: "left",
        mergeCss: true,
        cssOverrides: {
            drawerBody: css`
                width: ${pxToRem(390)};
            `,
            drawerContent: css`
                justify-content: space-between;
            `,
        },
    },
    sectionWrapper: {
        css: css`
            margin-top: ${pxToRem(12)};
            border-top: 1px solid ${getColor("menu.mainNavigation.separator")};
            padding-top: ${pxToRem(12)};

            &:first-child {
                border: none;
                padding-top: 0;
            }
        `,
    },
    myProductsButton: {
        variant: "primary",
        sizeVariant: "large",
        icon: {
            position: "right",
            src: ChevronRight,
        },
        mergeCss: true,
        css: css`
            display: flex;
            margin: ${pxToRem(0, 20)};
        `,
    },
    accountNavigationDrawerAccordion: {
        iconSrc: PersonLine,
        extendedStyles: {
            panel: {
                css: css`
                    padding-top: 0;
                    padding-bottom: 0;
                    padding-left: ${pxToRem(45)} !important; /* override default icon padding-left */
                `,
            },
        },
    },
    accountCollapsableSideMenu: smallCollapsableSideMenuProps,
    customerNavigationDrawerAccordion: {
        iconSrc: HomePin,
    },
    customerAddressLabel: {
        forwardAs: "p",
        css: css`
            ${spacingStyles(null, pxToRem(4))}
            color: ${getColor("text.light")};
            font-size: ${x => x.theme.design.typography.size.tiny};
            font-weight: ${x => x.theme.design.typography.weight.medium};
            text-transform: uppercase;
        `,
    },
    customerAddress: {
        extendedStyles: {
            addressText: {
                forwardAs: "p",
                css: css`
                    ${spacingStyles(null, pxToRem(8))}
                    font-weight: ${x => x.theme.design.typography.weight.medium};
                `,
            },
        },
    },
    changeAccountLink: {
        css: css`
            ${linkActionStyles()}
            ${spacingStyles(pxToRem(4), null)}
        `,
    },
    secondaryNavigationWrapper: {
        css: css`
            margin: ${pxToRem(24, 16, 16)};
            background-color: ${getColor("common.accent")};
            border-radius: ${pxToRem(8)};
            padding: ${pxToRem(12, 0)};
        `,
    },
    languageMenuNavigationDrawerAccordion: { iconSrc: LanguageLine },
    languageMenuNavigationDrawerLink: {
        extendedStyles: {
            link: {
                css: css`
                    padding-left: 0;
                    padding-right: 0;
                `,
            },
        },
    },
};

const styles = navigationDrawerStyles;

const NavigationDrawer: FC<NavigationDrawerProps> = ({ isCompactHeaderFlyout, uniqueId, rootElementSelector }) => {
    const dispatch = useAppDispatch();
    const navDrawerIsOpen = useAppSelector(x => x.components.addressDrawer.navDrawerIsOpen);
    const flyoutDrawerIsOpen = useAppSelector(x => x.components.addressDrawer.flyoutDrawerIsOpen);
    const isAuthenticated = useAppSelector(x => x.context.session.isAuthenticated);
    const billTosDataView = useAppSelector(x => getBillTosDataView(x, {}));
    const shipTosDataView = useAppSelector(x => getCurrentShipTosDataView(x));
    const billTo = useAppSelector(x => getCurrentBillToState(x).value);
    const shipTo = useAppSelector(x => getCurrentShipToState(x).value);
    const currentLocation = useLocation();
    const languages = useAppSelector(x => getLanguages(x));
    const { firstName, language, lastName, userName } = useSession();
    const {
        searchSettings: { searchPath },
    } = useSettingsCollection();

    const headerPage = useHeaderPage();
    // getWidgetsByPageId maps over the widget ids, so it returns a new array on every call. Compare
    // shallowly (the widget objects themselves are stable store references) so this doesn't re-render
    // the drawer on every dispatched action.
    const headerWidgets = useAppSelector(x => getWidgetsByPageId(x, headerPage.id), shallowEqual);
    const secondaryNavigationWidgets = headerWidgets
        .filter(x => secondaryNavigationZones.includes(x.zone))
        .sort((a, b) => secondaryNavigationZones.indexOf(a.zone) - secondaryNavigationZones.indexOf(b.zone));
    const languageMenuWidget = secondaryNavigationWidgets.find(x => x.type === "Common/LanguageMenu");
    const secondaryNavigationLinkFields = secondaryNavigationWidgets
        .filter(x => x.type === "Header/HeaderLinkList")
        .reduce((a, b) => a.concat(b.fields.links), [] as LinkModelWithIcon[]);
    const { links: secondaryNavigationLinks } = useGetLinks(secondaryNavigationLinkFields, x => x.fields.destination);

    const orderUploadLink = usePageLinkByPageType(constants.pageType.orderUpload);
    const quickOrderLink = usePageLinkByPageType(constants.pageType.cart);
    const myAccountLink = usePageLinkByPageType(constants.pageType.myAccount);

    useEffect(() => {
        if (isAuthenticated) {
            if (!billTo) {
                dispatch(loadCurrentBillTo());
            }

            if (!shipTo) {
                dispatch(loadCurrentShipTo());
            }

            if (!billTosDataView.isLoading && !billTosDataView.value) {
                dispatch(loadBillTos());
            }

            if (!shipTosDataView.isLoading && !shipTosDataView.value) {
                dispatch(loadCurrentShipTos());
            }
        }
    }, []);

    if (useIsDuplicate("NavigationDrawer", uniqueId)) {
        return null;
    }

    const openDrawer = () => {
        if (isCompactHeaderFlyout) {
            dispatch(setFlyoutDrawerIsOpen({ isOpen: true }));
        } else {
            dispatch(setNavDrawerIsOpen({ navDrawerIsOpen: true }));
        }

        dispatch(setInitialValues({}));
    };

    const closeDrawer = () => {
        if (isCompactHeaderFlyout) {
            dispatch(setFlyoutDrawerIsOpen({ isOpen: false }));
            setTimeout(() => dispatch(setFlyoutDrawerIsOpen({ isOpen: undefined })), 300);
            return;
        }

        dispatch(setNavDrawerIsOpen({ navDrawerIsOpen: false }));
        setTimeout(() => dispatch(setNavDrawerIsOpen({ navDrawerIsOpen: undefined })), 300);
    };

    const currentPageUrl = currentLocation.pathname;
    const isMyAccountSection = Boolean(
        myAccountLink?.url && currentPageUrl.toLowerCase().startsWith(myAccountLink.url.toLowerCase()),
    );
    const isOpen = isCompactHeaderFlyout ? flyoutDrawerIsOpen : navDrawerIsOpen;
    const mainMenuTitle = translate("Main menu");
    const showChangeCustomerLink =
        (billTosDataView.value && billTosDataView.value.length > 1) ||
        (shipTosDataView.value && shipTosDataView.value.length > 2);

    const renderSecondaryNavigationLinks = (withOrWithoutIconsOnly?: boolean) => {
        return secondaryNavigationLinks.map(({ title, url }, index) => {
            const { icon, openInNewWindow, overriddenTitle } = secondaryNavigationLinkFields[index].fields;
            const iconSrc = headerLinkListIcons[icon]?.src;
            const _title = overriddenTitle || title;

            if (
                !_title ||
                !url ||
                (withOrWithoutIconsOnly === true && !iconSrc) ||
                (withOrWithoutIconsOnly === false && iconSrc)
            ) {
                return null;
            }

            return (
                <NavigationDrawerLink
                    {...styles.secondaryNavigationDrawerLink}
                    href={url}
                    iconSrc={withOrWithoutIconsOnly === false ? undefined : iconSrc}
                    isCurrent={currentPageUrl === url}
                    key={`${_title}${index}`}
                    onClick={closeDrawer}
                    target={openInNewWindow ? "_blank" : undefined}
                    text={_title}
                />
            );
        });
    };

    return (
        <>
            <Button {...styles.drawerTrigger} onClick={openDrawer}>
                <ButtonIcon {...styles.drawerTriggerIcon} />
                <VisuallyHidden>{mainMenuTitle}</VisuallyHidden>
                <AccountMessagesCount {...styles.drawerTriggerAccountMessagesCountStyles} />
            </Button>
            <Drawer
                {...styles.drawer}
                closeButtonAccessibleText={translate("Close Menu")}
                contentLabel={mainMenuTitle}
                draggable
                drawerContentForwardAs="div"
                handleClose={closeDrawer}
                headline={mainMenuTitle}
                hideHeadline
                isOpen={isOpen}
                rootElementSelector={rootElementSelector}
            >
                <StyledWrapper {...styles.primaryNavigationWrapper}>
                    <StyledWrapper {...styles.sectionWrapper}>
                        <Button {...styles.myProductsButton} href={`${searchPath}?query=`} onClick={closeDrawer}>
                            {translate("Products")}
                        </Button>
                    </StyledWrapper>
                    <StyledWrapper {...styles.sectionWrapper}>
                        <NavigationDrawerAccordion
                            {...styles.accountNavigationDrawerAccordion}
                            text={translate("My Account")}
                            subText={firstName ? `${firstName}${lastName ? ` ${lastName}` : ""}` : userName}
                            defaultExpanded={isMyAccountSection}
                        >
                            <CollapsableSideMenu
                                {...styles.accountCollapsableSideMenu}
                                pageType={constants.pageType.myAccount}
                                showRootPage
                                showSignOut
                                onClick={closeDrawer}
                            />
                        </NavigationDrawerAccordion>
                    </StyledWrapper>
                    <StyledWrapper {...styles.sectionWrapper}>
                        <NavigationDrawerAccordion
                            {...styles.customerNavigationDrawerAccordion}
                            text={`${translate("Sold To")} / ${translate("Ship To")}`}
                        >
                            <Typography {...styles.customerAddressLabel}>
                                {translate("{0}:", translate("Sold To"))}
                            </Typography>
                            <InlineAddress {...styles.customerAddress} address={billTo} />
                            <Typography {...styles.customerAddressLabel}>
                                {translate("{0}:", translate("Ship To"))}
                            </Typography>
                            <InlineAddress {...styles.customerAddress} address={shipTo} />
                            {showChangeCustomerLink && (
                                <Link
                                    {...styles.changeAccountLink}
                                    onClick={() => {
                                        dispatch(setChangeCustomerModalIsOpen({ isOpen: true }));
                                        closeDrawer();
                                    }}
                                >
                                    {translate("Change Account")}
                                </Link>
                            )}
                        </NavigationDrawerAccordion>
                    </StyledWrapper>
                    {(quickOrderLink?.url || orderUploadLink?.url) && (
                        <StyledWrapper {...styles.sectionWrapper}>
                            {quickOrderLink?.url && (
                                <NavigationDrawerLink
                                    {...styles.tertiaryNavigationDrawerLink}
                                    href={quickOrderLink.url}
                                    iconSrc={PowerBolt}
                                    isCurrent={currentPageUrl === quickOrderLink.url}
                                    onClick={closeDrawer}
                                    text={translate("Quick Order")}
                                />
                            )}
                            {orderUploadLink?.url && (
                                <NavigationDrawerLink
                                    {...styles.tertiaryNavigationDrawerLink}
                                    href={orderUploadLink.url}
                                    iconSrc={Upload}
                                    isCurrent={currentPageUrl === orderUploadLink.url}
                                    onClick={closeDrawer}
                                    text={translate("Order Upload")}
                                />
                            )}
                        </StyledWrapper>
                    )}
                </StyledWrapper>
                <StyledWrapper {...styles.secondaryNavigationWrapper}>
                    {renderSecondaryNavigationLinks(false)}
                    <StyledWrapper {...styles.sectionWrapper}>
                        {Boolean(languageMenuWidget) && (
                            <NavigationDrawerAccordion
                                {...styles.languageMenuNavigationDrawerAccordion}
                                text={language?.description}
                            >
                                {languages?.map(x => {
                                    const isCurrent = language?.id === x.id;

                                    return (
                                        <NavigationDrawerLink
                                            {...styles.languageMenuNavigationDrawerLink}
                                            key={x.id}
                                            isCurrent={isCurrent}
                                            onClick={() => {
                                                if (isCurrent) {
                                                    return;
                                                }

                                                dispatch(setLanguage({ languageId: x.id }));
                                                closeDrawer();
                                            }}
                                            text={x.description}
                                        />
                                    );
                                })}
                            </NavigationDrawerAccordion>
                        )}
                        {renderSecondaryNavigationLinks(true)}
                    </StyledWrapper>
                </StyledWrapper>
            </Drawer>
        </>
    );
};

export default NavigationDrawer;
